module.exports = __webpack_public_path__ + "static/media/fitnessBoySignup.bbb28590.png";